import Body from "../components/Body";
import AboutSection from "../components/AboutSection";
import ProductsSection from "../components/ProductsSection";
import SustainabilitySection from "../components/SustainabilitySection";
import FAQSection from "../components/FAQSection";
import MainLayout from "../layouts/MainLayout";

export default function Home() {
  return (
    <MainLayout>
      <Body />
      <AboutSection />
      <ProductsSection />
      <SustainabilitySection />
      <FAQSection />
    </MainLayout>
  );
}